// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  // apiUrl: 'http://localhost:1235/rozie/'
  baseUrl: 'https://rozie-shared-insight-adpter-devtest.rozie.ai/review_tool/',
  webchat: {
    feedbackFileURL: 'http://localhost:5000/'
  },
  azuread: {
    tenant: '2e3f5a44-d5c4-4713-ab78-584b9a84b91c',
    clientId: '8b66dd8d-a5e1-4203-83f1-34c708e64c4e',
    endpoints: {
      "http://localhost:4200/": '2e3f5a44-d5c4-4713-ab78-584b9a84b91c' // Note, this is an object, you could add several things here
    },
    logoutURL: "https://login.microsoftonline.com/aircsuptsbxisu1webcac1/oauth2/logout?client_id=8b66dd8d-a5e1-4203-83f1-34c708e64c4e&post_logout_redirect_uri=https://review.rozie.ai/"
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
